/* eslint-disable jsx-a11y/anchor-is-valid */
import Table, { ColumnsType } from "antd/lib/table";
import { Link } from "react-router-dom";
import { MPagination } from "../../../../../helper/pagination";
import { Action, ActionType } from "../../../customer/entity/customer.model";
import { Entity } from "../../../shared/shared.model";
import { mConstants } from "../../../../../helper/constants";

/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  Product,
  ProductUI,
} from "../../entity/product.model";
import helper from "../../../../../helper/helper";
import { Form } from "antd";
import CustomImage from "../../../../../component/CustomImage";
import { useEffect, useState } from "react";

const getProductTableColumns = (imageUrls: { [key: string]: string }): ColumnsType<ProductUI> => [
  {
    title: "Д/д",
    dataIndex: "index",
    key: "index",
  },
  {
    title: "Зураг",
    dataIndex: "imagePath",
    key: "imagePath",
    render: (imagePath: string | null) => {
      if (!imagePath) return null;

      const imageUrl = imageUrls[imagePath];
      if (!imageUrl) return null;

      return (
        <CustomImage
          alt={imagePath}
          src={imageUrl}
          width={35}
        />
      );
    },
  },
  {
    title: "Нэр",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Дотоод код",
    dataIndex: "article",
    key: "article",
  },
  {
    title: "Брэнд",
    dataIndex: "brand",
    key: "brand",
    render: (brand: Entity | null) => brand ? brand.name : "",
  },
  {
    title: "Ангилал",
    dataIndex: "category",
    key: "category",
    render: (category: Entity | null) => category ? category.name : "",
  },
  {
    title: "Үйлдлүүд",
    align: "center",
    key: "actions",
    dataIndex: "actions",
    render: (actions: Action[], record: ProductUI) => (
      <div className="list-icons">
        <div className="dropdown">
          <a href="#" className="list-icons-item" data-toggle="dropdown">
            <i className="icon-menu9"></i>
          </a>

          <div className="dropdown-menu dropdown-menu-right">
            {actions.map((action: Action) => {
              if (action.type === ActionType.edit) {
                return (
                  <Link
                    key={`action-${record.uuid}`}
                    to={`/products/${record.uuid}`}
                    className="dropdown-item"
                  >
                    <i className={action.icon}></i>
                    {action.text}
                  </Link>
                );
              } else {
                return <></>;
              }
            })}
          </div>
        </div>
      </div>
    ),
  },
];

export interface ProductTableProps {
  pagination: MPagination<Product>;
  onChange: (page: number, pageSize: number) => void;
}

function ProductTable(props: ProductTableProps) {
  const [imageUrls, setImageUrls] = useState<{ [key: string]: string }>({});

  useEffect(() => {
    // Product зургуудыг blob-оор татаж авч object URL үүсгэх
    const loadImages = async () => {
      const urls: { [key: string]: string } = {};
      
      for (const product of props.pagination.results) {
        if (product.imagePath) {
          try {
            const url = await helper.getImageUrl(product.imagePath);
            if (url) {
              urls[product.imagePath] = url;
            }
          } catch (error) {
            console.error(`Failed to load image: ${product.imagePath}`, error);
          }
        }
      }
      
      setImageUrls(urls);
    };

    loadImages();

    // Cleanup: object URL-уудыг устгах
    return () => {
      Object.values(imageUrls).forEach((url) => URL.revokeObjectURL(url));
    };
  }, [props.pagination.results]);

  const productUIs: ProductUI[] = props.pagination.results.map(
    (product, index) => {
      const actions: Action[] = [
        { icon: "icon-pencil3", text: "Дэлгэрэнгүй", type: ActionType.edit },
      ];
      return {
        ...product,
        actions: actions,
        index: index + 1,
        key: index,
      };
    }
  );

  return (
    <Table
      className="table table-responsive"
      columns={getProductTableColumns(imageUrls)}
      dataSource={productUIs}
      pagination={{
        defaultCurrent: 1,
        total: props.pagination.count,
        onChange: props.onChange,
      }}
    />
  );
}

export default ProductTable;
